import type { DraftQuestion, GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';

export type FieryRouteChoice = {
  id: string;
  label: string;
  correct: boolean;
  mediaUrl?: string;
};

export type FieryRouteLevel = {
  id: number;
  seed: string;
  questionId: string;
  prompt: string;
  promptMediaUrl?: string;
  choices: FieryRouteChoice[];
};

type RouteSource = Pick<GameDraft | PublishedGame, 'id' | 'maxLevels' | 'questions'>;

function toLevelQuestion(question: DraftQuestion, level: number, sourceId: string): FieryRouteLevel {
  return {
    id: level,
    seed: `${sourceId}:${question.id}:${level}`,
    questionId: question.id,
    prompt: question.prompt,
    promptMediaUrl: question.media?.url,
    choices: question.choices.map((choice) => ({
      id: choice.id,
      label: choice.text,
      correct: choice.isCorrect,
      mediaUrl: choice.media?.url,
    })),
  };
}

export function draftToFieryRouteLevels(source: RouteSource): FieryRouteLevel[] {
  return Array.from({ length: source.maxLevels }, (_, index) => {
    const level = index + 1;
    const question = source.questions.find((candidate) => candidate.levels[0] === level);
    if (!question) throw new Error(`${level}. seviye sorusu bulunamadı.`);
    return toLevelQuestion(question, level, source.id);
  });
}
